import * as moduloCorretora from './store'

export function corretoraModule({ store }) {
  store.registerModule('corretora', {
    ...moduloCorretora,
    namespaced: true,
  })
}
